import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthEmployerGuard } from 'src/app/gaurd/auth-employer.guard';
import { AuthGuard } from 'src/app/gaurd/auth.guard';
import { MessageComponent } from './message.component';

const routes: Routes = [
  {
    path: '',
    component: MessageComponent,
    data: {
      title: 'message',
    },
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MessageRoutingModule {}
